import { useRef as s, useEffect as f } from "react";
const l = (e) => {
  const n = typeof e == "function", t = s(e);
  f(() => {
    t.current = e;
  }), f(() => {
    if (n) {
      const o = (r) => {
        const u = t.current(r);
        if (typeof u == "string")
          return r.preventDefault(), r.returnValue = u;
        if (r.defaultPrevented)
          return r.returnValue = "";
      };
      return window.addEventListener("beforeunload", o), () => {
        window.removeEventListener("beforeunload", o);
      };
    }
  }, [n]);
}, a = ({ children: e = null, onBeforeunload: n }) => (l(n), e);
export {
  a as Beforeunload,
  l as useBeforeunload
};
//# sourceMappingURL=react-beforeunload.js.map
